import { MAP_TILE_LAYERS, TileLayerControl } from "../parcellaire";
import { MapContainer, TileLayer, WMSTileLayer } from "react-leaflet";

import { Box } from "@mui/material";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";
import { useState } from "react";

OrthoimageMap.propTypes = {
    rgbOrthoOutputBinaryData: PropTypes.shape(MODEL_PROPTYPES.OutputBinaryData)
        .isRequired,
};

export function OrthoimageMap({ rgbOrthoOutputBinaryData }) {
    const [selectedTileLayer, setSelectedTileLayer] = useState(
        MAP_TILE_LAYERS.SATELLITE
    );

    const boundingBox = rgbOrthoOutputBinaryData.others?.boundingBox;
    const bounds = boundingBox ? [boundingBox[0], boundingBox[2]] : undefined;

    const layerName = rgbOrthoOutputBinaryData.others?.layerName;

    return (
        <Box sx={{ height: "100%", position: "relative", zIndex: 0 }}>
            <Box
                sx={{
                    backgroundColor: "silver",
                    position: "absolute",
                    p: 0.75,
                    borderRadius: 1,
                    bottom: 10,
                    right: 10,
                    zIndex: 1,
                }}
            >
                <TileLayerControl
                    selectedTileLayer={selectedTileLayer}
                    setSelectedTileLayer={setSelectedTileLayer}
                />
            </Box>
            <MapContainer
                attributionControl={false}
                bounds={bounds}
                center={bounds ? undefined : [26.0, 30.0]}
                zoom={bounds ? undefined : 3}
                maxZoom={25}
                minZoom={3}
                maxBounds={[
                    [-90, -270],
                    [90, 270],
                ]}
                maxBoundsViscosity={0.8}
                style={{
                    height: "100%",
                    backgroundImage: "url(/static/mapbg.png)",
                    backgroundSize: "1300px",
                    zIndex: 0,
                }}
            >
                <TileLayer
                    url={selectedTileLayer.url}
                    minZoom={2}
                    maxNativeZoom={17}
                    maxZoom={25}
                />
                <WMSTileLayer
                    key={layerName}
                    layers={layerName}
                    url={process.env.REACT_APP_GEOSERVER_URL}
                    format="image/png"
                    transparent
                    opacity={1}
                    maxZoom={25}
                    tiled
                />
            </MapContainer>
        </Box>
    );
}
